<template>
  <div class="yh container">
      <el-input placeholder="请输入关键字快速检索" prefix-icon="el-icon-search" v-model="input" class="input-with-select" clearable @change = "doFilter" size="small">
        <el-select v-model="select" slot="prepend" placeholder="请选择">
          <el-option label="检索全部" value="1"></el-option>
          <el-option label="车牌" value="2"></el-option>
          <el-option label="姓名" value="3"></el-option>
        </el-select>
      </el-input>

    <el-button style="float: right" id= "out" type="success" size="medium" round @click = "dialogFormVisible2 = true">批量导出</el-button>

    <div style="clear:both;"></div>
      <el-table
        v-loading="loading"
        element-loading-text="加载中"
        stripe
        :data="yh.slice((currentPage-1)*pagesize,currentPage*pagesize)"
        style="width: 100%"
        :row-class-name="tableRowClassName">
        <el-table-column
          type="index"
          width="100"
          align="center">
        </el-table-column>

        <el-table-column
          prop="cph"
          label="车牌"
          width="200px"
          align="center">
        </el-table-column>

        <el-table-column
          prop="name"
          label="检查人"
          align="center">
        </el-table-column>

        <el-table-column
          prop="danwei"
          label="单位"
          width="250"
          align="center">
        </el-table-column>

        <el-table-column
          prop="ny"
          label="检查时间"
          align="center">
          <template slot-scope="scope">
            {{ToTime(scope.row.ny)}}
          </template>
        </el-table-column>

        <el-table-column
          label="状态"
          align="center">
          <template slot-scope="scope">
            <el-tag
              :type="zt(scope.row) == '无隐患' ? 'success' : 'danger'" disable-transitions>{{zt(scope.row)}}</el-tag>
          </template>
        </el-table-column>

        <el-table-column label="操作" width="200" align="center">
          <template slot-scope="scope">
            <el-tooltip class="item" effect="dark" content="详情" placement="left">
              <el-button type="primary" size="mini" icon="el-icon-more" @click="handleYh(scope.$index, scope.row)"></i></el-button>
            </el-tooltip>
            <el-button type="danger" size="mini" icon="el-icon-delete" @click="handleDelete(scope.$index, scope.row)"></el-button>
          </template>
        </el-table-column>
      </el-table>

        <el-pagination
        v-show="pageshow"
          background
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
          :current-page="currentPage"
          :page-sizes="[10, 20, 50, 100, 1000]"
          :page-size="pagesize"
          layout="total, sizes, prev, pager, next, jumper"
          :total="total">
        </el-pagination>


    <el-dialog title="批量导出" :visible.sync="dialogFormVisible2" width="340px">
          <el-form :model="form2" :rules="rules2" ref="ruleForm2" status-icon>
            <el-form-item label="导出年月" :label-width="formLabelWidth" prop="ny">
              <el-select v-model="form2.ny" placeholder="请选择">
                <el-option
                  v-for="item in nyitem"
                  :key="item"
                  :label="item"
                  :value="item">
                </el-option>
              </el-select>
            </el-form-item>
          </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="dialogFormVisible2 = false">取 消</el-button>
        <el-button type="primary" @click="submitForm2('ruleForm2');">确 定</el-button>
      </div>
    </el-dialog>




    <el-dialog title="隐患详情" :visible.sync="dialogFormVisible" width="1000px">
      <el-row type="flex" justify="space-around">
        <el-col :span="12">
          <el-checkbox-group v-model="form.all" @change="handleCheckedChange">
            <p class = "hang"
            v-for="obj in newoptions"
            :key="'ph'+obj.value">
              <el-checkbox :label="obj.value">{{obj.value}}.{{obj.label}}</el-checkbox>
            </p>
          </el-checkbox-group>
          <p class="grid-content bg-purple-light">整改措施: <br>{{form.ps}}</p>
        </el-col>

        <el-col :span="8">
          <el-card v-if='form.msg1' shadow="hover" :body-style="{'text-align':'center',padding: '5px'}">
            <img :src="'/apis/'+form.msg1" class="image" @click="openimg('/apis/'+form.msg1)">
          </el-card>
          <el-card v-if='form.msg2' shadow="hover" :body-style="{'text-align':'center',padding: '5px'}">
            <img :src="'/apis/'+form.msg2" class="image" @click="openimg('/apis/'+form.msg2)">
          </el-card>
          <el-card v-if='form.msg3' shadow="hover" :body-style="{'text-align':'center',padding: '5px'}">
            <img :src="'/apis/'+form.msg3" class="image" @click="openimg('/apis/'+form.msg3)">
          </el-card>
        </el-col>
      </el-row>

      <div slot="footer" class="dialog-footer">
        <el-button type="success" @click="out()">导　出</el-button>
        <el-button type="primary" @click="dialogFormVisible = false">确　定</el-button>
      </div>
    </el-dialog>

    <el-dialog
          :visible.sync="innerVisible"
          append-to-body>
          <img :src ="src" height="100%" width="100%"></img>
    </el-dialog>

  </div>
</template>

<script>
  export default {
    computed:{
      zt(){
        return function (val) {
          let length = val.all.length
          if (val.clx == '2'){
            if (length == 17) return '无隐患'
            else return (17-length)+'个隐患' 
          }else{
            if (length == 24) return '无隐患'
            else return (24-length)+'个隐患'     
          }
        }
      },
      yh(){
        return (this.dw.length > 0) ? this.dw : this.$store.state.yh;
      },
      dw(){
        return this.$store.getters.getYh(this.input,this.select);
      },
      total(){
        return this.yh.length;
      },
      pageshow(){
        return this.total > 0;
      },
      nyf(){
        return this.$store.state.nyf;
      },
      nyitem(){
        return this.$store.state.nyh;
      },
      newoptions(){
        let newop = [...this.options];
        if (this.form.clx == '2') newop = this.options.filter(todo=>['4','9','10','12','13','14','15'].indexOf(todo.value) == -1);
        return newop;
      }
    },
    data(){
      var checkNy = (rule, value, callback) => {
        if (value == '') {
          callback(new Error('请选择分类'));
        } else {
          callback();
        }
      };
      return{
        src:'',
        image:[],
        input: '',
        select: "1",
        pagesize:100,
        currentPage:1,//默认开始页面
        loading: true,
        innerVisible:false,
            dialogFormVisible: false,
            dialogFormVisible2: false,
            form: {},
            form2: {
                ny: '',
            },
            formLabelWidth: '120px',
        rules:{
              name: [
                { required: true, message: '请填写单位名称', trigger: 'blur' },
              ]
        },
        rules2:{
              ny: [
                { validator:checkNy, trigger: 'change' }
              ]
        },
          options:[
            {
              label: '按要求悬挂机动车号牌且拍照完好无损，号码清晰',
              value: '1'
            },{
              label: '车辆随车携带行驶证且正常审验',
              value: '2'
            },{
              label: '车辆随车携带道路运输证且正常审验',
              value: '3'
            },{
              label: '车辆随车携带安全卡',
              value: '4'
            },{
              label: '车辆随车携带有效保险',
              value: '5'
            },{
              label: '按要求张贴车辆年检标志',
              value: '6'
            },{
              label: '驾驶人携带驾驶证',
              value: '7'
            },{
              label: '驾驶人是否逾期未换证',
              value: '8'
            },{
              label: '驾驶人具备有效的危化品运输车辆资格证',
              value: '9'
            },{
              label: '有押运员，且押运员是否进行岗前培训且持证上岗',
              value: '10'
            },{
              label: '车容外观整洁，无私自改装，反光标志完整',
              value: '11'
            },{
              label: '车辆安装紧急切断装置,且无任何异常',
              value: '12'
            },{
              label: '罐体漆面完好，无渗漏现象',
              value: '13'
            },{
              label: '危险货物运输警示灯具符合要求安装规范',
              value: '14'
            },{
              label: '车辆有安全告示牌，安全警示标志',
              value: '15'
            },{
              label: '千斤顶、灭火器、停车应急三角警示牌、三角木齐全',
              value: '16'
            },{
              label: '车辆有安全带，雨刷、喇叭正常、有误损坏',
              value: '17'
            },{
              label: '驾驶室内无易燃物品',
              value: '18'
            },{
              label: '有车辆日常检验、维修记录',
              value: '19'
            },{
              label: '车辆动态监管系统正常运行',
              value: '20'
            },{
              label: '仪表提示正常，完好无损',
              value: '21'
            },{
              label: '左、右及内后视镜、左右转向灯、刹车灯、近远光灯、应急灯完好无损，正常工作',
              value: '22'
            },{
              label: '车辆与行驶证照片一致',
              value: '23'
            },{
              label: '车辆两侧及后方安装防护装置',
              value: '24'
            }
          ],
      }
    },
    components:{
    },
    methods:{
      handleCheckedChange(value) {
        this.form = {...this.backup};
        // let checkedCount = value.length;
        // this.checkAll = checkedCount === this.cities.length;
        // this.isIndeterminate = checkedCount > 0 && checkedCount < this.cities.length;
      },
      openimg(src){
        this.innerVisible=true;
        this.src = src;
      },
      doFilter(val) {
        if (this.dw.length == 0) this.$message({showClose: true,message: '没有找到包含【'+val+'】的内容',type: 'warning'});
      },
      handleSizeChange(val) {
        this.pagesize = val;
      },
      handleCurrentChange(val) {
        this.currentPage = val;
      },

      ToTime (cjsj) {
        var date = new Date(Number(cjsj)*1000) //时间戳为10位需*1000，时间戳为13位的话不需乘1000
        var Y = date.getFullYear() + '/';
        var M = (date.getMonth()+1 < 10 ? '0'+(date.getMonth()+1) : date.getMonth()+1) + '/';
        var D = (date.getDate() < 10 ? '0'+date.getDate() : date.getDate()) + '';
        // var h = date.getHours() + ':'
        // var m = date.getMinutes() + ':'
        // var s = date.getSeconds()
        if (D.length == 1) D = '0'+ D;
        var str = Y+M+D;
        if (str.indexOf("NaN") != -1) return null;
        else return str;
      },

      submitForm2(formName) {

        this.$refs[formName].validate((valid) => {
          if (valid) {
            this.$message({showClose: true,message: '提交中……'});
            this.dialogFormVisible2 = false;

            var params = new URLSearchParams();
            params.append('token', 'dqgU1wqtfzcZRAniU');
            params.append('admin', this.$store.getters.name);
            params.append('my', this.$store.getters.token);
            params.append('ny', this.form2.ny);
            this.$ajax.post("/apis/yh.php",params).then((ret) => {
                console.log(ret)
                if (ret.data.msg == true) {
                  this.$message({showClose: true,message: '导出成功,请查看下载',type: 'success'});
                  window.location = ret.data.src;  
                }else this.$notify.error({title: '错误',message: ret.data});
            }).catch(err=>{
              console.log(err)
                this.$notify.error({title: '错误',message: '网络异常'});
            });

          } else {
            this.$message({showClose: true,message: '导出年月未选择',type: 'warning'});
            return false;
          }
        });

      },
      handleYh(i,r){
        this.dialogFormVisible = true;
        this.form = {...r};
        this.backup = {...r};
      },
      handleDelete(i,r){
            this.$confirm('此操作将永久删除该项, 是否继续?', '提示', {
              confirmButtonText: '确定',
              cancelButtonText: '取消',
              type: 'warning'
            }).then(() => {
              this.loading = true;
              this.$message({showClose: true,message: '删除中……'});

              var params = new URLSearchParams();
              params.append('token', 'sqgU1wqtfzcZRAniU');
              params.append('admin', this.$store.getters.name);
              params.append('my', this.$store.getters.token);
              params.append('id', r.id);
              this.$ajax.post("/apis/yh.php",params).then((ret) => {
                        this.loading = false;
                        console.log(ret.data);
                        if (ret.data == true) {
                          this.$store.commit('delYh', r);
                          this.$message({showClose: true,type: 'success',message: '删除成功!'});
                        }else this.$notify.error({title: '错误',message: ret.data});
              }).catch(err=>{
                  this.$notify.error({title: '错误',message: '网络异常'});
                  this.loading = false;
              });



            }).catch(() => {
              this.$message({showClose: true,type: 'info',message: '已取消'});          
            });
      },
      tableRowClassName({row, rowIndex}) {
        return '';
      },
      getYh(){
        var params = new URLSearchParams();
        params.append('token', 'cqgU1wqtfzcZRAniU');
        params.append('admin', this.$store.getters.name);
        params.append('my', this.$store.getters.token);
        this.$ajax.post("/apis/yh.php",params).then((ret) => {
              // console.log(ret.data);
              this.loading = false;
              if (ret.data != "token错误" && ret.data != "数据库连接失败") {
                this.$store.commit('setYh', ret.data.sort(this.compare));
              }else this.$notify.error({title: '错误',message: ret.data});
        }).catch(err=>{
            console.log(err);
            this.$notify.error({title: '错误',message: '网络异常'});
            this.loading = false;
        });
      },
      out(){
        var params = new URLSearchParams();
        params.append('token', 'wqgU1wqtfzcZRAniU');
        params.append('admin', this.$store.getters.name);
        params.append('my', this.$store.getters.token);
        params.append('id', this.form.id);
        this.$ajax.post("/apis/yh.php",params).then((ret) => {
          console.log(ret.data);
              if (ret.data.msg == true) {
                this.$message({showClose: true,message: '导出成功,请查看下载',type: 'success'});
                window.location = ret.data.src;  
              }else this.$notify.error({title: '错误',message: ret.data});
        }).catch(err=>{
            console.log(err);
            this.$notify.error({title: '错误',message: '网络异常'});
            this.loading = false;
            console.log(err);
        });
      },
      compare(v1, v2){
        if (Number(v1.id) < Number(v2.id)){
          return 1;
        }else if (Number(v1.id) > Number(v2.id)){
          return -1;
        }else{
          return 0;
        }
      }
    },
    created(){
      if (this.dw.length == 0) this.getYh();
      else this.loading = false;
    }
  }
</script>

<style scoped>
  .hang{
    padding-bottom: 5px;
  }
  .el-pagination{
      display: flex;
      justify-content:center;
      align-items:center;
  }
  .el-select {
    width: 150px;
  }
  .el-input {
    width: 500px;
  }
  .input-with-select .el-input-group__prepend {
    background-color: #fff;
    float: left;
  }

  .el-card{
    max-width: 100%;
    /*max-height: 150px;*/
    margin-bottom: 10px;
  }
  .el-col img{
    width: 100%;
    /*max-height: 150px;*/
  }

  .el-carousel__item img{
        margin:0 auto;display:block
  }

  .bg-purple-dark {
    background: #99a9bf;
  }
  .bg-purple {
    background: #d3dce6;
  }
  .bg-purple-light {
    background: #e5e9f2;
  }
  .grid-content {
    /*text-align: center;*/
    padding-left: 10px;
    border-radius: 4px;
    min-height: 25px;
    line-height:25px;
  }
</style>


// WEBPACK FOOTER //
// src/components/Yh.vue